module.exports = __webpack_public_path__ + "img/icon_wx.f31ac8c5.png";